/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

var avatarDefaultProps = {
  hideOnLoadFailed: false,
  shape: "circle"
};
var avatarGroupDefaultProps = {
  cascading: "right-up",
  size: "medium"
};

export { avatarDefaultProps, avatarGroupDefaultProps };
//# sourceMappingURL=defaultProps.js.map
